import { useCallback, useEffect, useRef, useState } from "react";
import { scrollToElementWithOffset } from "../utils/scrollToElementWithOffset";
import { sessionStorage_keys } from "../constant/constant";
export function useMenuItemScroll() {
  const [isNavigating, setIsNavigating] = useState(false);
  const timeoutsRef = useRef<number[]>([]);

  // Cleanup all timeouts on unmount
  useEffect(() => {
    return () => {
      timeoutsRef.current.forEach((t) => clearTimeout(t));
      timeoutsRef.current = [];
    };
  }, []);

  const handleItemScroll = useCallback(
    async (id: string) => {
      if (isNavigating) return; // prevent double click
      setIsNavigating(true);
      sessionStorage.setItem(sessionStorage_keys.isSidebarClicking, "true");

      // Small delay before starting scroll
      const startTimeout = window.setTimeout(async () => {
        try {
          await scrollToElementWithOffset(id);
        } catch (err) {
          console.error("Sidebar navigation error:", err);
        } finally {
          // Reset flag after 1 second
          const endTimeout = window.setTimeout(() => {
            sessionStorage.setItem(sessionStorage_keys.isSidebarClicking, "false");
            setIsNavigating(false);
          }, 1000);
          timeoutsRef.current.push(endTimeout);
        }
      }, 1);

      timeoutsRef.current.push(startTimeout);
    },
    [isNavigating, sessionStorage_keys]
  );

  return { handleItemScroll, isNavigating };
}
